import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User, Project, Inspection, Defect } from '../services/api';

interface AppState {
  user: User | null;
  token: string | null;
  projects: Project[];
  inspections: Inspection[];
  defects: Defect[];
  selectedProjectId: string | null;
  // Actions
  setAuth: (user: User, token: string) => void;
  clearAuth: () => void;
  setProjects: (projects: Project[]) => void;
  setInspections: (inspections: Inspection[]) => void;
  setDefects: (defects: Defect[]) => void;
  updateDefect: (defect: Defect) => void;
  setSelectedProject: (id: string | null) => void;
}

export const useStore = create<AppState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      projects: [],
      inspections: [],
      defects: [],
      selectedProjectId: null,
      setAuth: (user, token) => set({ user, token }),
      clearAuth: () => set({ user: null, token: null }),
      setProjects: (projects) => set({ projects }),
      setInspections: (inspections) => set({ inspections }),
      setDefects: (defects) => set({ defects }),
      updateDefect: (defect) =>
        set(state => ({ defects: state.defects.map(d => d.id === defect.id ? defect : d) })),
      setSelectedProject: (id) => set({ selectedProjectId: id }),
    }),
    {
      name: 'surfaceiq-storage',
      partialize: (state) => ({ user: state.user, token: state.token, selectedProjectId: state.selectedProjectId }),
    }
  )
);
